/* eslint-disable */
import { fetchValidateAddressWeb } from '../../repositories/price-estimator/v1/validate-address-web';
import { fetchGetFlatAreasDesktop } from '../../repositories/price-estimator/v1/get-flat-areas-desktop';
import { setError } from '../../actions/filters';
import { EActionTypes } from './types';
import { actionGenerator } from '../../utils/actionGenerator';
var RESPONSE = EActionTypes.FLAT_AREA_SUCCESS_RESPONSE;
export var setFlatAreaResponse = actionGenerator(RESPONSE);
export function getFlatAreasSuggest(selectedAddress) {
  return function (dispatch, getState, context) {
    var httpApi = context.httpApi;
    return fetchValidateAddressWeb({
      httpApi: httpApi,
      parameters: {
        address: selectedAddress
      }
    }).then(function (response) {
      if (response.statusCode === 200) {
        return fetchGetFlatAreasDesktop({
          httpApi: httpApi,
          parameters: {
            address: selectedAddress
          }
        });
      }

      return Promise.reject(response);
    }).then(function (response) {
      if (response.statusCode === 200) {
        var flatAreas = response.response.flatAreas;
        dispatch(setFlatAreaResponse({
          flatAreas: flatAreas
        }));
      }
    }).catch(function (response) {
      if (response.statusCode === 400) {
        var errors = response.response.errors || [];
        var error = errors[0] || {};
        var key = error.key,
            message = error.message;

        if (key && message) {
          dispatch(setError({
            currentErrorField: key,
            errorText: message
          }));
        }
      } else {
        context.logger.error(response);
      }
    });
  };
}